import {Helpers} from "../../../services/Helpers";
import Web3Connection from "../../../services/web3Connection";

// https://web3js.readthedocs.io/en/v1.2.6/web3-net.html
// https://wiki.parity.io/JSONRPC-net-module
// https://nethermind.readthedocs.io/en/latest/jsonrpc.html

const defaultInput = `{
    "method":"eth_getBalance",
    "params":["0x0000000000000000000000000000000000000000"],
    "id":1,
    "jsonrpc":"2.0"
}`;

const FETCH_STATUS = {
    INITIAL: 0,
    PENDING: 1,
    OK: 2,
    FAILED: 3,
}

export default {
    name: 'rpc-calls',
    template: require('./RpcCalls.html'),
    data() {
        return {
            arbitraryInput: defaultInput,
            output: '',
            link: ''
        }
    },
    validations: {
    },
    created() {
        const target = this.$parseQuery.get('target');

        if (target === 'ec-recover') {
            this.input = this.$parseQuery.get('ec-recover-input');
            this.signature = this.$parseQuery.get('ec-recover-signature');
        }

        if (localStorage.latestNodeUrl && localStorage.latestNodeUrl.length > 0) {
            this.rpcUrl = localStorage.latestNodeUrl;
        }
    },
    methods: {
        async arbitraryRequest() {
            await Web3Connection.execute(async web3 => {
                let parsed;
                try {
                    parsed = JSON.parse(this.arbitraryInput);
                } catch (e) {
                    this.output = e;
                    return;
                }
                web3.currentProvider.send(parsed, (error, result) => {
                    if (error) {
                        this.output = error;
                    } else {
                        this.output = JSON.stringify(result, null, 2);
                    }
                });
            });
        },
        async predefinedRequest() {
        },
        copyLink(e) {
            e.preventDefault();

            console.log('🔗', this.link);

            Helpers.copyToClipboard(this.link);
        }
    }
}
